import React from 'react'
import Loader from '../loader/Loader'

const Exchanges = () => {

  // if (isFetching) return <Loader />
  
  return (
    <div>Exchanges</div>
  )
}

export default Exchanges